import { useCallback, useState } from "react";
import { useFocusEffect } from "@react-navigation/native";

import useAppState from "../../hooks/useAppState";

import * as Notifications from "expo-notifications";
import { useCurrentUser } from "../../hooks";
import { NotificationPermission } from "../../hooks/useCurrentUser";

export function usePushNotificationsPermissionStatus() {
  const isAppActive = useAppState();
  const [permissionStatus, setPermissionStatus] = useState<NotificationPermission>(NotificationPermission.UNDETERMINED);
  async function load() {
    const permissions = await Notifications.getPermissionsAsync();

    const status = {
      denied: NotificationPermission.DENIED,
      granted: NotificationPermission.GRANTED,
      undetermined: NotificationPermission.UNDETERMINED,
    }[permissions.status];

    if (status) setPermissionStatus(status);
  }

  useFocusEffect(
    useCallback(() => {
      if (isAppActive) load();
    }, [isAppActive])
  );

  return permissionStatus;
}

export function useSettingsBadgeCount(acknowledgedState: NotificationPermission) {
  const permission = usePushNotificationsPermissionStatus();
  return permission === NotificationPermission.DENIED && acknowledgedState !== NotificationPermission.DENIED ? 1 : 0;
}

export function useSetBadgeAcknowledged(acknowledgedState: NotificationPermission) {
  const { setAcknowledgedNotificationBadgeState } = useCurrentUser();
  useFocusEffect(
    useCallback(() => {
      setAcknowledgedNotificationBadgeState(acknowledgedState);
    }, [acknowledgedState])
  );
}
